export default __webpack_public_path__ + "static/media/AL luik linksdraaiend.jpg";